module.exports = __webpack_public_path__ + "img/ex3.b0c32ecd.png";